import React, { useState } from "react";
import { HighlightText } from "../common/HighlightText";

const DigitalSolutions = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const uploadUrl = process.env.REACT_APP_UPLOAD_URL;

  return (
    <section className="how-its-work-area ptb-70">
      <div className="container">

        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col-lg-10" data-aos="fade-up" data-aos-duration="1200">
            <div className="section-title">
              {data?.title && (
                // <h2 dangerouslySetInnerHTML={{ __html: data.title }} />
                <h2><HighlightText content={data.title} /></h2>
              )}

              {data?.description?.map((block, i) => {
                if (block.type === "paragraph") {
                  return (
                    <p key={i}>
                      {block.children.map(c => c.text).join("")}
                    </p>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>

        <div className="row align-items-center">

          {/* LEFT SIDE CONTENT */}
          <div className="col-lg-6 col-md-12" data-aos="fade-up" data-aos-duration="1200">
            <div className="how-its-work-content">
              <div className="inner-box">
                {data?.strategyContents?.map((item, index) => (
                  <div
                    key={index}
                    className={`single-item ${activeIndex === index ? "active" : ""}`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <div className="count-box">{index + 1}</div>

                    <h3><HighlightText content={item.title} /></h3>

                    {item?.description?.map((block, i) => {
                      if (block.type === "paragraph") {
                        return (
                          <p key={i}>
                            {block.children.map(c => c.text).join("")}
                          </p>
                        );
                      }
                      return null;
                    })}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE IMAGE */}
          <div className="col-lg-6 col-md-12">
            <div className="how-its-work-image">
              {data?.strategyContents?.map((item, index) => (
                <img
                  key={index}
                  src={`${uploadUrl}${item.image?.url}`}
                  className={`${activeIndex === index ? "active-img" : ""}`}
                  alt={item.image?.alternativeText || item.title}
                />
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default DigitalSolutions;
